import { FC } from "react";
import { Redeem } from "@mui/icons-material";

import { useMetamask, useWriteContractWithSimulation } from "@dzambalaorg/react-hooks-eth";
import { ListAction, ListActionVariant } from "@framework/styled";
import { AddressType, type IRaffleToken, TokenStatus } from "@framework/types";
import RaffleGetPrizeABI from "@framework/abis/json/LotteryRandom/getPrize.json";

export interface IRaffleRewardButtonProps {
  className?: string;
  disabled?: boolean;
  token: IRaffleToken;
  variant?: ListActionVariant;
}

export const RaffleRewardButton: FC<IRaffleRewardButtonProps> = props => {
  const { className, disabled, token, variant } = props;

  const { writeContractAsync } = useWriteContractWithSimulation();

  const { execute: metaFn } = useMetamask(async (ticket: IRaffleToken) => {
    return writeContractAsync({
      address: token.round.contract!.address as AddressType,
      abi: RaffleGetPrizeABI,
      functionName: "getPrize",
      args: [ticket.tokenId, token.round.roundId],
    });
  });

  const handleReward = (ticket: IRaffleToken): (() => Promise<void>) => {
    return async () => {
      return metaFn(ticket).then(() => {
        // TODO reload page
      });
    };
  };

  if (token.metadata.PRIZE) {
    return null;
  }

  return (
    <ListAction
      onClick={handleReward(token)}
      icon={Redeem}
      message="form.tips.redeem"
      className={className}
      disabled={disabled || token.tokenStatus !== TokenStatus.MINTED || token.tokenId !== token.round.number}
      data-testid="RaffleRewardButton"
      variant={variant}
    />
  );
};
